<template>

    <project-form
        :info-uri="infoUri"
    ></project-form>

</template>

<script>

import ProjectForm from "../../../components/Projects/Form";

export default {

    components: {
        ProjectForm,
    },

    computed: {
        infoUri() {
            return this.route('api.v1.projects.info');
        }
    },

    metaInfo: {
        title:'Project toevoegen',
    },

    name:'ProjectFormAdd',

}

</script>
